"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgWifi = function SvgWifi(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M28.06 26.295a1 1 0 01-1.16 1.63 5 5 0 00-5.79 0 1 1 0 01-1.16-1.63 7 7 0 018.11 0zm3.66-3.513a1 1 0 01-1.28 1.536 10 10 0 00-12.8 0 1 1 0 01-1.28-1.536 12 12 0 0115.36 0zm3.521-3.532a1 1 0 01-1.322 1.5 15 15 0 00-19.838 0 1 1 0 01-1.322-1.5c6.424-5.663 16.058-5.663 22.482 0z",
    id: "wifi_svg__a"
  }));
};

var _default = SvgWifi;
exports["default"] = _default;